var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { markInvoicePaidStart, markInvoicePaidSucceeded, markInvoicePaidFailed, markInvoiceUnPaidStart, markInvoiceUnPaidSucceeded, markInvoiceUnPaidFailed, } from "./invoice.actions";
import { GENERATOR_PARAMS } from "./invoice.constants";
var getExtraDefaultState = function () { return ({
    markInvoicePaid: {},
    markInvoiceUnPaid: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(markInvoicePaidStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { markInvoicePaid: __assign(__assign({}, state.markInvoicePaid), (_a = {}, _a[payload.id] = {
            isMarkingInvoicePaid: true,
            markPaidInvoiceError: undefined,
        }, _a)) });
});
reducer.on(markInvoicePaidSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { markInvoicePaid: __assign(__assign({}, state.markInvoicePaid), (_a = {}, _a[payload.id] = {
            isMarkingInvoicePaid: false,
            markPaidInvoiceError: undefined,
        }, _a)) });
});
reducer.on(markInvoicePaidFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { markInvoicePaid: __assign(__assign({}, state.markInvoicePaid), (_a = {}, _a[payload.id] = {
            isMarkingInvoicePaid: false,
            markPaidInvoiceError: payload.error,
        }, _a)) });
});
reducer.on(markInvoiceUnPaidStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { markInvoiceUnPaid: __assign(__assign({}, state.markInvoiceUnPaid), (_a = {}, _a[payload.id] = {
            isMarkingInvoiceUnPaid: true,
            markUnInvoicePaidError: undefined,
        }, _a)) });
});
reducer.on(markInvoiceUnPaidSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { markInvoiceUnPaid: __assign(__assign({}, state.markInvoiceUnPaid), (_a = {}, _a[payload.id] = {
            isMarkingInvoiceUnPaid: false,
            markUnInvoicePaidError: undefined,
        }, _a)) });
});
reducer.on(markInvoiceUnPaidFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { markInvoiceUnPaid: __assign(__assign({}, state.markInvoiceUnPaid), (_a = {}, _a[payload.id] = {
            isMarkingInvoiceUnPaid: false,
            markUnInvoicePaidError: payload.error,
        }, _a)) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
